export default {
  farms: [],
  isFetchingFarms: false,
  farmsError: {},
};
